import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "wrapper-burger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["burger", { 'burger-active': $props.modelValue }]),
        onClick: $setup.toggleBurger
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", null, null, -1),
        _createElementVNode("div", null, null, -1),
        _createElementVNode("div", null, null, -1)
      ]))], 2)
    ]),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1
        }, null, -1)
      ]))]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wrapper-input" }, null, -1))
  ]))
}